import { useEffect, useState } from 'react';

// Check for pendo every half second
const POLLING_INTERVAL = 500;

// For 1 minute
const POLLING_ATTEMPTS = 120;

export function useResourceCenter() {
   const [resourceCenter, setResourceCenter] = useState<any>(null);

   useEffect(() => {
      let attempts = 0;

      // In case there is a race condition in loading pendo, poll until
      //  we find the resource center, or run out of retries.
      const interval = setInterval(() => {
         attempts++;
         const result =
            globalThis?.window?.pendo?.BuildingBlocks?.BuildingBlockResourceCenter?.getResourceCenter();
         if (result) {
            clearInterval(interval);
            setResourceCenter(result);
         }
         if (attempts > POLLING_ATTEMPTS) {
            clearInterval(interval);
         }
      }, POLLING_INTERVAL);

      return () => clearInterval(interval);
   }, []);

   return resourceCenter;
}
